// extracted by mini-css-extract-plugin
export default {"container":"SelectEmail_container__Miy+F","subText":"SelectEmail_subText__leJzd","title":"SelectEmail_title__wqzoE"};